exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-content[data-v-8952cfda] {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\n}\n.colored[data-v-8952cfda] {\r\n  background: #f5f7f9;\n}\r\n", ""]);

// exports
